import { resolveValidationMessageKey } from '~/utils/validationMessages';

/**
 * Resolves a vee-validate `errorMessage`/`errors[0]` string (a legacy `common.validation.*`
 * identifier set by a yup/zod schema) to its translated text in the `validation` i18n
 * namespace. Unknown/blank identifiers pass through untranslated (see
 * `resolveValidationMessageKey`), matching schemas that already carry a plain string.
 */
export const useValidationMessage = () => {
  const { t } = useI18n();

  const resolveValidationMessage = (message?: string | null): string => {
    const { key, params, translate } = resolveValidationMessageKey(message);
    if (!translate) return key;
    return params ? t(key, params) : t(key);
  };

  return {
    resolveValidationMessage,
  };
};
